import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import './dialogs.css';

const Confirm = ({
  visible,
  title,
  message,
  cancelCaption,
  confirmCaption,
  onSave,
  onClose,
}) => (
  <Modal show={visible} onHide={onClose}>
    {title && (
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
    )}
    <Modal.Body>{message}</Modal.Body>
    {cancelCaption && confirmCaption && (
      <Modal.Footer>
        {cancelCaption && (
          <Button variant="secondary" onClick={onClose}>
            {cancelCaption}
          </Button>
        )}
        {onSave && confirmCaption && (
          <Button variant="success" onClick={onSave}>
            {confirmCaption}
          </Button>
        )}
      </Modal.Footer>
    )}
  </Modal>
);
export default Confirm;
